export const POWERBI_ENTITY_NAME = 'SS_QI_REPORT_SETUP';

export const POWERBI_ENABLED_APP_SETTING = 'PowerBI/Enabled';
export const POWERBI_RIGHT_TO_ACCESS_IMPORT = 'QI_IMPORT_REPORT';

export const MASTER_DATASET_REPORT_STATUS = 'n/a';

export const IMPORT_STEPS = {
  INITIAL_STEP: 0,
  UPLOAD_FILE: 1,
  START_IMPORT: 2,
  FILE_PROCESSING: 3,
  UPLOAD_COMPLETED: 4,
};

export const STEPS_DESCRIPTION = ['Upload a File', 'Start Import', 'File Processing', 'Completed'];

export const IMPORT_POLLING_TIME = process.env.NODE_ENV === 'test' ? 0 : 3000;
export const EXPORT_POLLING_TIME = process.env.NODE_ENV === 'test' ? 0 : 5000;

export const STATUSES = {
  COMPLETED: 'Completed',
  IN_PROGRESS: 'InProgress',
};

export const MIN_HEADER_HEIGHT = 54;
export const PAGE_CONTAINER_PADDINGS = 55;

export const EXPORT_TYPES = [
  { label: 'PDF', value: 'pdf' },
  { label: 'PPTX', value: 'pptx' },
];

export const CREATE_REPORT_OPTIONS = [
  { value: 'new', label: 'Create new' },
  { value: 'existing', label: 'Create based on existing' },
];
